import api from "../axios";

export const getTypeList = async (project) => {
  const res = await api.get("/approval/types/list/", { params: { project } });
  return res.data;
};

export const saveType = async (project, payload) => {
  const res = await api.post("/approval/types/save/", payload, { params: { project } });
  return res.data;
};

export const deleteType = async (project, id) => {
  const res = await api.delete("/approval/types/delete/", { params: { project, id } });
  return res.data;
};


// 단건
export const getTypeDetail = async (projectId, id) => {
  const res = await api.get(`/approval/types/detail/${id}/`, {
    params: { project: projectId },
  });
  return res.data;
};